<template>
  <!-- Geometrie + Typo 1:1 live (.referenz-uebersicht #cat-nav, gemessen 1440/1024):
       Zellen large-8/large-11 offset-1 (8.333% + 10px Zellpadding), Strich
       hr.stroke 55x3 mit 30px Abstand, Hauptliste ul.topics.semi-large
       (26px rubrik-regular, Zeilenhöhe 3rem, 20px Abstand), Nebenliste
       ul.topics.grey (Body-Größe, lowercase, #999), Reset rechts (semi-large).
       Trenner "/" und Aktiv-Zustand: .wg-topics in der Site-CSS. -->
  <!-- Abstand zum Raster (live gemessen): 26px unter 480, sonst 21px; mit
       Kontaktleiste kollabiert er mit deren größerem Margin. -->
  <div ref="rootEl" class="team-filter mb-[26px] font-base min-[480px]:mb-[21px]">
   <div class="-mt-[5px] md:ml-[calc(8.333%+10px)] md:mr-2.5">
    <span class="mb-[30px] block h-[3px] w-[55px] rounded-sm bg-accent-1" aria-hidden="true"></span>
    <!-- live h2 > strong: rubrik-bold, h2-Größen 22/24/33px, lh 1.3, uppercase, ls .6px; h2-Margin .5rem + 20px Zellpadding bis zur Liste -->
    <p class="mb-7 text-[22px] font-bold uppercase leading-[1.3] tracking-[0.6px] text-accent-1 min-[480px]:text-[24px] md:text-[33px]">Direkt &amp; Persönlich</p>

    <!-- Schmal (<480, wo live das Select steht): Button + Panel von unten statt
         der langen Listen (Finn 07.10.2026). Aktiver Filter als Label mit X. -->
    <div class="flex flex-wrap items-center gap-x-5 gap-y-3 min-[480px]:hidden">
      <button
        ref="triggerEl"
        type="button"
        class="btn"
        aria-haspopup="dialog"
        :aria-expanded="sheetOpen ? 'true' : 'false'"
        aria-controls="team-filter-sheet"
        @click="openSheet"
      >
        Filtern
      </button>
      <button v-if="active" type="button" class="inline-flex items-center gap-2 text-[20px] font-extralight leading-[1.4]" @click="reset">
        <span>{{ active }}</span>
        <span class="font-bold text-accent-1" aria-hidden="true">X</span>
        <span class="sr-only">Filter entfernen</span>
      </button>
    </div>

    <div class="hidden min-[480px]:block">
      <ul v-if="names.length" class="wg-topics mb-5 text-[20px] leading-[3rem] min-[480px]:text-[26px]">
        <!-- linked: Personen des Fotos unter dem Mauszeiger (Hover-Hervorhebung, Stil in der Site-CSS) -->
        <li v-for="c in names" :key="'m-' + c" :class="{ active: active === c, linked: linked.includes(c) }">
          <button type="button" @click="setFilter(c)">{{ c }}</button>
        </li>
      </ul>

      <ul v-if="roles.length" class="wg-topics wg-topics-grey mb-0 lowercase leading-[1.6] text-[#999]">
        <li v-for="t in roles" :key="'s-' + t" :class="{ active: active === t }">
          <button type="button" @click="setFilter(t)">{{ t }}</button>
        </li>
      </ul>

      <div class="text-right">
        <button
          type="button"
          class="pr-[15px] text-[20px] font-extralight leading-[1.4] text-default min-[480px]:text-[26px]"
          @click="reset"
        >
          <span class="font-bold text-accent-1" aria-hidden="true">X</span> Alle anzeigen
        </button>
      </div>
    </div>
   </div>

    <!-- Kontaktleiste bei gewählter Person (live .action-bar / contactText):
         NICHT eingerückt, live Zelle large-6 (10px Zellpadding ab 480, ab 768
         halbe Breite) — die Buttons stehen unter 768 und bei 1024 untereinander,
         bei 1440 nebeneinander (24px). Schrift = Body-Größe 17/18/19px. Abstände live gemessen
         bei 375/600/1024/1440. Optik wie die ActionButtons
         (.wg-action-link), kurz lime aufblitzend nach dem Filtern (live .animation). -->
    <Transition enter-active-class="wg-team-contact-enter">
      <div
        v-if="contact"
        :key="contact.name"
        class="mb-[30px] mt-[76px] flex flex-col items-start gap-y-[9px] text-[17px] min-[480px]:mb-[45px] min-[480px]:mt-[75px] min-[480px]:gap-y-[10px] min-[480px]:px-2.5 md:mt-[76px] md:w-1/2 md:flex-row md:flex-wrap md:gap-x-6 md:text-[18px] min-[1200px]:text-[19px]"
        :class="{ 'wg-team-contact-flash': animating }"
      >
        <a v-if="contact.phone" :href="contact.tel" class="wg-action-link group relative block py-[5px] pl-[65px] pr-[10px] leading-[1.4em] text-accent-2">
          <span class="wg-team-contact-icon absolute left-0 top-0 flex h-9 w-9 items-center justify-center bg-accent-2 text-white transition-colors duration-300 group-hover:bg-accent-1">
            <span class="wg-icon wg-icon-tel h-5 w-5" aria-hidden="true"></span>
          </span>
          <span class="wg-team-contact-chevron absolute left-[46px] top-[7px] text-[0.9em] leading-[1.556] transition-colors duration-300 group-hover:text-accent-1" aria-hidden="true">&gt;</span>
          <span class="sr-only">{{ contact.name }} anrufen: </span>{{ contact.phone }}
        </a>
        <a v-if="contact.email" :href="'mailto:' + contact.email" class="wg-action-link group relative block py-[5px] pl-[65px] pr-[10px] leading-[1.4em] text-accent-2">
          <span class="wg-team-contact-icon absolute left-0 top-0 flex h-9 w-9 items-center justify-center bg-accent-2 text-white transition-colors duration-300 group-hover:bg-accent-1">
            <span class="wg-icon wg-icon-mail h-5 w-5" aria-hidden="true"></span>
          </span>
          <span class="wg-team-contact-chevron absolute left-[46px] top-[7px] text-[0.9em] leading-[1.556] transition-colors duration-300 group-hover:text-accent-1" aria-hidden="true">&gt;</span>
          <span class="sr-only">E-Mail an {{ contact.name }}: </span>{{ contact.email }}
        </a>
      </div>
    </Transition>

    <Teleport to="body">
      <Transition enter-active-class="transition-opacity duration-300" leave-active-class="transition-opacity duration-200" enter-from-class="opacity-0" leave-to-class="opacity-0">
        <div v-if="sheetOpen" class="fixed inset-0 z-[1000] bg-black/50 min-[480px]:hidden" aria-hidden="true" @click="closeSheet"></div>
      </Transition>
      <Transition enter-active-class="transition-transform duration-300 ease-out" leave-active-class="transition-transform duration-200 ease-in" enter-from-class="translate-y-full" leave-to-class="translate-y-full">
        <div
          v-if="sheetOpen"
          id="team-filter-sheet"
          ref="sheetEl"
          role="dialog"
          aria-modal="true"
          aria-labelledby="team-filter-sheet-title"
          tabindex="-1"
          class="fixed inset-x-0 bottom-0 z-[1001] max-h-[85vh] overflow-y-auto rounded-t-2xl bg-white px-[15px] pb-[calc(25px+env(safe-area-inset-bottom))] pt-3 font-base text-default shadow-[0_-8px_30px_rgba(0,0,0,0.2)] focus:outline-none min-[480px]:hidden"
          @keydown.esc="closeSheet"
        >
          <span class="mx-auto mb-4 block h-1 w-10 rounded-full bg-[#ccc]" aria-hidden="true"></span>
          <div class="mb-4 flex items-center justify-between">
            <p id="team-filter-sheet-title" class="text-[22px] font-bold uppercase leading-[1.3] tracking-[0.6px] text-accent-1">Direkt &amp; Persönlich</p>
            <button ref="closeEl" type="button" class="-mr-2 p-2 text-[30px] font-extralight leading-none" aria-label="Schließen" @click="closeSheet">&times;</button>
          </div>

          <p v-if="names.length" class="mb-2 text-[15px] uppercase tracking-[0.6px] text-[#999]">Personen</p>
          <ul v-if="names.length" class="mb-6 flex flex-wrap gap-2">
            <li v-for="c in names" :key="'sm-' + c">
              <button
                type="button"
                class="rounded-full border px-4 py-2 text-[17px] leading-[1.3] transition-colors"
                :class="active === c ? 'border-accent-1 bg-accent-1 text-white' : 'border-[#ccc]'"
                :aria-pressed="active === c ? 'true' : 'false'"
                @click="choose(c)"
              >
                {{ c }}
              </button>
            </li>
          </ul>

          <p v-if="roles.length" class="mb-2 text-[15px] uppercase tracking-[0.6px] text-[#999]">Aufgaben</p>
          <ul v-if="roles.length" class="mb-6 flex flex-wrap gap-2">
            <li v-for="t in roles" :key="'ss-' + t">
              <button
                type="button"
                class="rounded-full border px-4 py-2 text-[15px] lowercase leading-[1.3] transition-colors"
                :class="active === t ? 'border-accent-1 bg-accent-1 text-white' : 'border-[#ccc] text-[#777]'"
                :aria-pressed="active === t ? 'true' : 'false'"
                @click="choose(t)"
              >
                {{ t }}
              </button>
            </li>
          </ul>

          <button type="button" class="text-[20px] font-extralight leading-[1.4]" @click="choose(null)">
            <span class="font-bold text-accent-1" aria-hidden="true">X</span> Alle anzeigen
          </button>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<script>
import { ref, computed, nextTick, onMounted, onBeforeUnmount } from 'vue'

// Baut aus den server-gerenderten Team-Kacheln zwei Filterzeilen — Personen
// (data-persons) und Rollen (data-roles) — und ordnet das Mosaik wie live
// (webEdition "lw-items") neu: Personen-Filter und "Alle anzeigen" verteilen die
// passenden Kacheln per Slot (Index mod 20) auf die beiden Hälften mit festen
// Größen, Rollen-Filter zeigt sie gleich groß in einem Raster ("eqalPictures").
// Personen-Filter stellt Porträtfotos (data-team-portrait) nach vorn, wie live
// sortPortrait(). Wie live höchstens 60 Kacheln (itemsInPage, kein Pager).
// Single-Select: ein Klick aktiviert/deaktiviert genau ein Label. Hover über
// einem Foto hebt die damit verknüpften Namen in der Personenliste hervor.
const MAX_TILES = 60
const LEFT_SLOTS = [1, 2, 5, 6, 7, 11, 12, 15, 16, 17]
const isPortrait = (tile) => (tile.dataset.teamPortrait === 'true' ? 1 : 0)
// "0421 - 347 90 90" → "tel:+494213479090"
const telHref = (phone) => {
  const digits = phone.replace(/[^\d+]/g, '')
  return 'tel:' + (digits.startsWith('0') ? '+49' + digits.slice(1) : digits)
}
// TeamSection-Property contacts: pro Zeile "Name; Telefon; E-Mail".
const parseContacts = (text) => {
  const map = {}
  ;(text || '').split(/\r?\n/).forEach((line) => {
    const [name, phone = '', email = ''] = line.split(';').map((part) => part.trim())
    if (name && (phone || email)) map[name] = { name, phone, email, tel: phone ? telHref(phone) : null }
  })
  return map
}
const slotSize = (slot) => ([1, 8, 12, 19].includes(slot) ? 8 : [3, 4, 6, 7, 13, 14, 16, 17].includes(slot) ? 6 : 4)

export default {
  name: 'TeamFilter',
  setup() {
    const rootEl = ref(null)
    const names = ref([])
    const roles = ref([])
    const active = ref(null)
    // Personen (data-persons, mehrere kommagetrennt) der Kachel unter dem Mauszeiger.
    const linked = ref([])
    // Mobiles Filter-Panel (Bottom-Sheet)
    const sheetOpen = ref(false)
    const triggerEl = ref(null)
    const closeEl = ref(null)
    const desktopQuery = window.matchMedia('(min-width: 480px)')
    // Kontaktdaten je Person; Leiste nur bei aktivem Personenfilter mit Eintrag.
    const contacts = ref({})
    const contact = computed(() => (active.value && !roles.value.includes(active.value) ? contacts.value[active.value] || null : null))
    // Live .animation: 1s nach jedem Filterklick (Kacheln schrumpfen/wachsen, Kontakt-Icons lime).
    const animating = ref(false)
    let animationTimer = null
    let gridItems = null

    let tiles = []
    let cols = null

    const splitAttr = (value) =>
      (value || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)

    const sortDe = (arr) => arr.sort((a, b) => a.localeCompare(b, 'de'))

    const collect = (root) => {
      tiles = Array.from(root.querySelectorAll('[data-team-tile]')).sort(
        (a, b) => Number(a.dataset.teamIndex) - Number(b.dataset.teamIndex)
      )
      contacts.value = parseContacts(root.getAttribute('data-team-contacts'))
      gridItems = root.querySelector('[data-team-grid-items]')
      cols = {
        pair: root.querySelector('[data-team-cols]'),
        left: root.querySelector('[data-team-col="left"]'),
        right: root.querySelector('[data-team-col="right"]'),
        equal: root.querySelector('[data-team-col="equal"]'),
      }
      const ns = new Set()
      const rs = new Set()
      tiles.forEach((tile) => {
        splitAttr(tile.getAttribute('data-persons')).forEach((n) => ns.add(n))
        splitAttr(tile.getAttribute('data-roles')).forEach((r) => rs.add(r))
      })
      tiles.forEach((tile) => {
        tile.addEventListener('mouseenter', () => {
          linked.value = splitAttr(tile.getAttribute('data-persons'))
        })
        tile.addEventListener('mouseleave', () => {
          linked.value = []
        })
      })
      names.value = sortDe(Array.from(ns))
      roles.value = sortDe(Array.from(rs))
    }

    const apply = () => {
      if (!cols || !cols.left || !cols.right || !cols.equal) return
      const label = active.value
      const isRole = label !== null && roles.value.includes(label)
      const shown = tiles
        .filter((tile) => {
          if (!label) return true
          const attr = isRole ? 'data-roles' : 'data-persons'
          return splitAttr(tile.getAttribute(attr)).includes(label)
        })
      // Array.prototype.sort ist stabil: innerhalb der Gruppen bleibt die Reihenfolge.
      if (label && !isRole) shown.sort((a, b) => isPortrait(b) - isPortrait(a))
      shown.splice(MAX_TILES)

      // Nicht gezeigte Kacheln parken im (dann versteckten) Gleich-Raster.
      tiles.forEach((tile) => {
        if (!shown.includes(tile)) {
          tile.hidden = true
          cols.equal.appendChild(tile)
        }
      })

      shown.forEach((tile, index) => {
        tile.hidden = false
        if (isRole) {
          tile.dataset.teamSize = '3'
          cols.equal.appendChild(tile)
          return
        }
        const slot = (index % 20) + 1
        tile.dataset.teamSize = String(slotSize(slot))
        ;(LEFT_SLOTS.includes(slot) ? cols.left : cols.right).appendChild(tile)
      })

      cols.equal.hidden = !isRole
      if (cols.pair) cols.pair.hidden = isRole
    }

    const animate = () => {
      animating.value = true
      if (gridItems) {
        // Klasse neu setzen, damit die Animation auch bei schnellen Klicks neu startet.
        gridItems.classList.remove('wg-team-animating')
        void gridItems.offsetWidth
        gridItems.classList.add('wg-team-animating')
      }
      clearTimeout(animationTimer)
      animationTimer = setTimeout(() => {
        animating.value = false
        if (gridItems) gridItems.classList.remove('wg-team-animating')
      }, 1100)
    }

    const setFilter = (label) => {
      active.value = active.value === label ? null : label
      apply()
      animate()
    }

    const reset = () => {
      active.value = null
      apply()
      animate()
    }

    const onKeydown = (event) => {
      if (event.key === 'Escape') closeSheet()
    }

    const openSheet = () => {
      sheetOpen.value = true
      document.documentElement.style.overflow = 'hidden'
      document.addEventListener('keydown', onKeydown)
      nextTick(() => closeEl.value && closeEl.value.focus())
    }

    const closeSheet = () => {
      if (!sheetOpen.value) return
      sheetOpen.value = false
      document.documentElement.style.overflow = ''
      document.removeEventListener('keydown', onKeydown)
      nextTick(() => triggerEl.value && triggerEl.value.focus())
    }

    // Auswahl im Panel: wie Klick in der Liste (Toggle), null = alle; Panel schließt.
    const choose = (label) => {
      if (label === null) reset()
      else setFilter(label)
      closeSheet()
    }

    // Fenster über 480px gezogen: Panel ist dort ausgeblendet, also schließen.
    const onBreakpoint = (event) => {
      if (event.matches) closeSheet()
    }

    onBeforeUnmount(() => {
      clearTimeout(animationTimer)
      closeSheet()
      desktopQuery.removeEventListener('change', onBreakpoint)
    })

    onMounted(() => {
      desktopQuery.addEventListener('change', onBreakpoint)
      const root = rootEl.value && rootEl.value.closest('[data-team-grid]')
      if (!root) return
      collect(root)
    })

    return { rootEl, names, roles, active, linked, contact, animating, sheetOpen, triggerEl, closeEl, setFilter, reset, openSheet, closeSheet, choose }
  },
}
</script>
